<!--全局地图组件-->

<template>
  <div id='container' style='width: 100%; height: 300px'></div>
</template>
<script>
import { getLanguage } from '@/lang'
import { createPolyLine } from '@/components/Map/utils/polyline'
import bus from '@/utils/bus'
import { wgs84togcj02 } from '@/utils/postion'
import { CONST_DEFAULT_LAT, CONST_DEFAULT_LNG } from '@/common/constant'
import { createMarker } from '@/components/Map/utils/marker'
import { markerStart } from '@/components/Map/mapComponents/markers'

export default {
  props: {
    // 轨迹点
    trace: {
      type: Array
    }
  },
  data () {
    return {
      // 地图实例
      map: null
    }
  },
  mounted () {
    bus.$on('onMapTrace', (trace) => {
      const path = trace.map(item => (wgs84togcj02(item.lng, item.lat)))
      createPolyLine(this.map, path)
      const last = trace[trace.length - 1]
      this.map.setZoomAndCenter(18, wgs84togcj02(last.lng, last.lat))
      // 将轨迹点添加到地图上
      this.handleMarkers(trace)
    })
    // [AMap removed] this.map = new AMap.Map('container', {
    //   resizeEnable: true,
    //   center: [CONST_DEFAULT_LNG, CONST_DEFAULT_LAT],
    //   zoom: 16,
    //   lang: getLanguage().split('_')[0]
    // })
  },
  methods: {

    handleMarkers (trace) {
      return trace.map(item => {
        createMarker(item.lng, item.lat, {
          content: markerStart
        }).setMap(this.map)
      })
    }
  },
  beforeDestroy () {
    bus.$off('onMapTrace')
  }
}
</script>
